import { render } from "./ContractsPage.vue?vue&type=template&id=01baf2ba"
import script from "./ContractsPage.vue?vue&type=script&lang=js"
export * from "./ContractsPage.vue?vue&type=script&lang=js"

import "./ContractsPage.vue?vue&type=style&index=0&id=01baf2ba&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__